import type React from 'react'
import { useMediaQuery, useTheme, Box, Stack, Button, Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useState, useEffect, useRef } from 'react'
import TuneIcon from '@mui/icons-material/Tune'
import { VendorSearchState } from '../../states/useVendorSearchState'
import { ActiveSupplierFilters } from '../active-filters'

interface MobileFiltersBarProps {
  onFilterClick: () => void
  filters: VendorSearchState['filters']
  search: VendorSearchState['search']
}

export const MobileSupplierFilters: React.FC<MobileFiltersBarProps> = ({
  onFilterClick,
  filters,
  search,
}) => {
  const theme = useTheme()
  const isMediumAndBelow = useMediaQuery(theme.breakpoints.down('lg'))

  const [isSticky, setIsSticky] = useState(false)
  const filterBarRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleScroll = () => {
      if (filterBarRef.current) {
        const rect = filterBarRef.current.getBoundingClientRect()
        setIsSticky(rect.top <= 60)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  if (!isMediumAndBelow) {
    return null
  }

  return (
    <Box ref={filterBarRef}>
      <Box
        sx={{
          position: isSticky ? 'fixed' : 'relative',
          top: isSticky ? '60px' : 'auto',
          zIndex: 1100,
          transition: 'all 0.2s ease-in-out',
          py: 1,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            onClick={onFilterClick}
            startIcon={<TuneIcon />}
            variant="contained"
            color="inverted"
            sx={{
              borderRadius: 4,
              textTransform: 'none',
              fontSize: '0.875rem',
            }}
          >
            Show Filters
          </Button>
        </Stack>
      </Box>

      <ActiveSupplierFilters filters={filters} search={search} />
    </Box>
  )
}
